import { useSelector } from "react-redux";
import {
  getQuestionById,
  getQuestionsAndAnswers
} from "../../../../store/selectors";
import { useDispatch } from "react-redux";
import {
  QuestionIds,
  questionPresentationContent,
  questionRoutingLabels
} from "../../../../data/QuestionPresentation";
import { appraisalSlice } from "../../../../store/slices/Appraisal";
import { useNavigate } from "react-router-dom";
import { sendEvent, setAnalyticsLabel } from "../../../../helpers/analytics";

function useBodywork() {
  const QUESTION_ID = QuestionIds.EXTERIORBODYWORK;
  const NEXT_QUESTION_PATH = questionRoutingLabels[QuestionIds.TYRES];

  const conditionQuestion = useSelector(
    getQuestionById("Condition", QUESTION_ID)
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    pageTitle,
    component: { content },
    questionTooltip
  } = questionPresentationContent[QUESTION_ID];

  let showSelectValue: number;

  if ("showSelectValue" in content!) {
    ({ showSelectValue } = content);
  }

  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const answer = questionsAndAnswers && questionsAndAnswers[QUESTION_ID];

  const handleSubmit = (answers: number[] | null) => {
    const answer = answers && answers[0];
    if (answer === showSelectValue) {
      return dispatch(appraisalSlice.actions.setQuestionValidation("select"));
    }
    if (!answer) {
      return dispatch(appraisalSlice.actions.setQuestionValidation("radio"));
    }
    const photoQty = conditionQuestion.answers.find((a: { id: string }) => {
      return a.id.toString() === answer.toString();
    })?.imageQuantityRequired;
    dispatch(
      appraisalSlice.actions.setPhotosRequired({ [QUESTION_ID]: photoQty })
    );
    sendEvent("event", "interaction", {
      action: conditionQuestion.content,
      label: setAnalyticsLabel(conditionQuestion, answer),
    });
    navigate(`/${NEXT_QUESTION_PATH}`);
  };
  return {
    question: conditionQuestion,
    questionTooltip,
    questionTitle: conditionQuestion.content,
    pageTitle,
    handleSubmit,
    answer
  };
}

export default useBodywork;
